import apiBase from "../../api/axios";

/**
 * Obtiene el resumen unificado de fortalezas del estudiante autenticado.
 * GET /api/v1/fortalezas/fortaleza-talentos/summary-new/
 *
 * @returns {Object} { mis_fortalezas: [...] }
 */
export const getMisFortalezasSummaryService = async () => {
  const response = await apiBase.get(
    "v1/fortalezas/fortaleza-talentos/summary-new/"
  );
  return response.data;
};
